import { Dialog as DialogPrimitive } from 'radix-ui';
import { useTranslation } from 'react-i18next';
import { GLYPH } from './glyphs';

export interface LightboxProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  src: string;
  title: string;
  fileName?: string;
}

/**
 * Лайтбокс (README «Оверлеи»): подложка rgba(26,22,20,.82), изображение по центру,
 * подпись «{название} {файл} · нажмите, чтобы закрыть»; закрытие — клик в любом месте или Esc.
 */
export function Lightbox({ open, onOpenChange, src, title, fileName }: LightboxProps) {
  const { t } = useTranslation();
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-60 bg-scrim-lightbox" />
        <DialogPrimitive.Content
          aria-describedby={undefined}
          onClick={() => onOpenChange(false)}
          className="fixed inset-0 z-60 flex cursor-zoom-out flex-col items-center justify-center gap-14 p-40 focus-visible:outline-none"
        >
          <img
            src={src}
            alt={title}
            className="max-h-[75vh] max-w-[80vw] rounded-16 object-contain"
          />
          <div className="flex items-center gap-12">
            <DialogPrimitive.Title className="text-[14px] font-medium text-paper-pure">
              {title}
            </DialogPrimitive.Title>
            {fileName ? (
              <span className="text-[12px] text-lightbox-caption">{fileName}</span>
            ) : null}
            <span className="text-[12px] text-lightbox-caption">
              {GLYPH.middot} {t('lightbox.hint')}
            </span>
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
